/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Checkbox, Typography } from "@mui/material";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SelectedTemplates from "../../shared/ui/components/SelectedTemplates";
import {
  selectFormData,
  selectRecipientCountry,
} from "../../store/slicers/address";
import {
  declareOrder,
  getPrice,
  selectOrderPrice,
} from "../../store/slicers/order";
import usePriceStyles from "./style";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { getAmeriaPaymentOrder } from "../../store/slicers/payment";
import {
  selectChosenCardIDs,
  selectEnvelopes,
  selectGiftCards,
  selectLetters,
  selectPostCards,
  selectTextTemplates,
} from "../../store/slicers/template";
import { handleFindActiveItem } from "./helpers";
import Spinner from "../../shared/ui/components/Spinner";
import { hasUniqueID } from "../../shared/helpers/preOrder";
import Cookies from "js-cookie";
import Card from "../../assets/images/payment-icons/Card.jpeg";
import idramIcons from "../../assets/images/payment-icons/idram.png";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { ECountries } from "../../resources/constants";
import { selectCustomPriceState } from "../../store/slicers/app";

enum EPayments {
  AMERIA = "2",
  IDRAM = "3",
}

interface IIDram {
  edP_DESCRIPTION: string;
  edP_AMOUNT: string;
  edP_BILL_NO: string;
}

const Price = (): JSX.Element => {
  const [checked, setChecked] = useState<boolean>(true);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [radioButtonsValue, setRadioButtonValue] = useState<string>("");
  const orderPrice = useSelector(selectOrderPrice);
  const address = useSelector(selectFormData);
  const selectedRecipientCountry = useSelector(selectRecipientCountry);
  const textTemplates = useSelector(selectTextTemplates);
  const letters = useSelector(selectLetters);
  const envelops = useSelector(selectEnvelopes);
  const giftCards = useSelector(selectGiftCards);
  const postCards = useSelector(selectPostCards);
  const selectedCardIDs = useSelector(selectChosenCardIDs);
  const classes = usePriceStyles();
  const history = useHistory();
  const dispatch = useDispatch<any>();
  const customPrice = useSelector(selectCustomPriceState);

  const [idramResponse, setIdramResponse] = useState<IIDram | null>(null);
  const idramSubmitRef = useRef<any>();

  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioButtonValue((event.target as HTMLInputElement).value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const previousPageHandler = () => {
    if (Cookies.get("uniqueId")) {
      history.goBack();
    } else {
      window.location.href = "/";
    }
  };
  const orderDeclareData: any = useMemo(() => {
    const activeGiftCards = selectedCardIDs
      ? (Object.values(selectedCardIDs) as number[])
      : [];

    return {
      recipientName: address?.firstName,
      recipientSurName: address?.lastName,
      region:
        //edited
        address?.recipientCountry?.id !== ECountries.Armenia
          ? address?.customRegion
          : address?.region.name,
      district:
        //edited
        address?.recipientCountry?.id !== ECountries.Armenia
          ? address?.customDistrict
          : address?.district.name,
      street:
        //edited
        address?.recipientCountry?.id !== ECountries.Armenia
          ? address?.customStreet
          : address?.street?.name,
      building: !address?.house ? address?.building : address?.house,
      apartment: address?.apartment ? address?.apartment : "",
      phone: address?.countryWithCodes?.mobileCode.concat(address?.phoneNumber),
      email: address?.email,
      paymentMethod: Number(radioButtonsValue),
      postCode: "",
      countryID: address?.recipientCountry?.id,
      giftCardIDs: activeGiftCards?.length ? activeGiftCards : null,
      customPrice: 0,
    };
  }, [
    textTemplates,
    address,
    letters,
    envelops,
    giftCards,
    postCards,
    selectedCardIDs,
    radioButtonsValue,
  ]);

  const handlePayHandler = () => {
    if (hasUniqueID()) {
      dispatch(declareOrder(orderDeclareData)).then((res: any) => {
        if (res?.payload?.success) {
          if (radioButtonsValue === EPayments.AMERIA) {
            dispatch(
              getAmeriaPaymentOrder({
                order: res?.payload.orderID,
                language: "am",
                description: "Help foundation",
              })
            ).then((response: any) => {
              if (response?.payload) {
                //edited
                window.location.href = response?.payload.redirectUrl;
              }
            });
          } else if (radioButtonsValue === EPayments.IDRAM) {
            //idram
            setIdramResponse({
              ...res.payload.idramDeclareOrder,
            });
          }
        }
      });
    }
  };
  const summary = useMemo(() => {
    const selectedGiftCards: any = [];
    const activeGiftCards = selectedCardIDs
      ? (Object.values(selectedCardIDs) as number[])
      : [];

    giftCards.forEach((company: any) => {
      company.giftCards.forEach((card: any) => {
        if (activeGiftCards.includes(card.cardID)) {
          selectedGiftCards.push({ name: company.company, price: card.price });
        }
      });
    });
    const activePostCard = handleFindActiveItem(postCards);

    return (
      <Box
        border="1px solid lightgray"
        className={`${classes.summaryArea} summary`}
      >
        <div className={classes.summaryTitleArea}>
          <Typography variant="h6" color="#245fad">
            Ամփոփում
          </Typography>
        </div>
        {orderPrice === "0" ? (
          <div className={classes.summaryItem}>
            <div>Նվիրատվություն</div>
            <div>{customPrice}֏</div>
          </div>
        ) : null}
        {address?.recipientCountry?.id === ECountries.Armenia &&
        selectedGiftCards?.length
          ? selectedGiftCards.map((item: any, index: number) => {
              if (item?.price) {
                return (
                  <div className={classes.summaryItem} key={index}>
                    <div>Նվիրատվություն</div>
                    <div>
                      {item.price}
                      <span>֏</span>
                    </div>
                  </div>
                );
              }
            })
          : null}
        {activePostCard ? (
          <div className={classes.summaryItem}>
            <div>{activePostCard?.name}</div>
            <div>
              {activePostCard?.price} <span>֏</span>
            </div>
          </div>
        ) : null}
        <Box
          className={classes.summaryItem}
          borderTop="1px solid lightgray"
          bgcolor="lightgray"
        >
          <Typography variant="h6" color="#245fad">
            Ընդամենը
          </Typography>
          <Typography variant="h6" color="#245fad">
            {orderPrice}
            <span>֏</span>
          </Typography>
        </Box>
      </Box>
    );
  }, [orderPrice, selectedCardIDs, giftCards]);

  useEffect(() => {
    if (idramResponse) {
      idramSubmitRef.current.click();
    }
  }, [idramResponse]);

  useEffect(() => {
    if (selectedRecipientCountry) {
      const activeGiftCards = selectedCardIDs
        ? (Object.values(selectedCardIDs) as number[])
        : [];

      const activePostCard = handleFindActiveItem(postCards);
      const params: any = {
        countryID: selectedRecipientCountry?.id,
        postCardID: postCards?.length ? activePostCard?.postCardID : "",
        giftCardIDs: activeGiftCards?.length ? activeGiftCards : [],
      };

      dispatch(getPrice(params)).finally(() => setLoaded(true));
    }
    setLoaded(true);
  }, [selectedRecipientCountry, selectedCardIDs, postCards]);

  return (
    <Fragment>
      {!loaded ? (
        <div className={classes.spinnerWrapper}>
          <Spinner size={50} />
        </div>
      ) : (
        <div className={classes.root}>
          <p className={classes.rightPaneTitleResponsive}>
            Շնորհակալություն առողջական խնդիրներ ունեցող երեխաներին օգնելու համար
          </p>
          <div className={classes.row}>
            <div className={classes.leftPane}>
              <SelectedTemplates />
            </div>
            <div className={classes.rightPane}>
              <p className={classes.rightPaneTitle}>
                Շնորհակալություն առողջական խնդիրներ ունեցող երեխաներին օգնելու
                համար
              </p>
              {summary}
              <div className={classes.checkbox}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={checked}
                      onChange={handleChange}
                    />
                  }
                  label="Համաձայն եմ պայմանների հետ"
                />
              </div>
              <Box className={classes.paymentIconsArea}>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    aria-label="payments"
                    name="payments"
                    value={radioButtonsValue}
                    onChange={handleChangeRadio}
                  >
                    <Box className={classes.paymentIconsWrapper}>
                      <Box
                        display="flex"
                        alignItems="center"
                        mr={6}
                        className="responsive-icon"
                      >
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          value={EPayments.AMERIA}
                          control={<Radio color="primary" />}
                          label=""
                        />
                        <Box width={60} height={35}>
                          <img
                            className={classes.paymentIconsStyles}
                            src={Card}
                            alt="Card pay icon"
                          />
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        alignItems="center"
                        mr={5}
                        className="responsive-icon"
                      >
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          value={EPayments.IDRAM}
                          control={<Radio color="primary" />}
                          label=""
                        />
                        <Box height={30}>
                          <img
                            className={classes.paymentIconsStyles}
                            src={idramIcons}
                            alt="idram icon"
                          />
                        </Box>
                      </Box>
                      {/* <Box display="flex" alignItems="center">
                        <FormControlLabel
                          style={{ marginRight: 0 }}
                          value={EPayments.TELCELL}
                          control={<Radio />}
                          label=""
                        />
                        <Box height={30}>
                          <img
                            className={classes.paymentIconsStyles}
                            src={TelcellIcons}
                            alt="telcell icon"
                          />
                        </Box>
                      </Box> */}
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box margin="auto">
                <button
                  className={classes.skipBtn}
                  onClick={handlePayHandler}
                  disabled={!checked || !radioButtonsValue}
                >
                  Վճարել
                </button>
                <button
                  className={classes.prevBtn}
                  onClick={previousPageHandler}
                >
                  <ArrowBackIcon />
                </button>
              </Box>
            </div>
          </div>
        </div>
      )}
      <form
        action="https://money.idram.am/payment.aspx"
        style={{ display: "none" }}
        method="POST"
        acceptCharset="utf-8"
      >
        <input type="hidden" name="EDP_LANGUAGE" value="EN" />
        <input
          type="hidden"
          name="EDP_REC_ACCOUNT"
          value={process.env.REACT_APP_IDRAM_REC_ACCOUNT}
        />
        <input
          type="hidden"
          name="EDP_DESCRIPTION"
          value={idramResponse?.edP_DESCRIPTION}
        />
        <input
          type="hidden"
          name="EDP_AMOUNT"
          value={idramResponse?.edP_AMOUNT}
        />
        <input
          type="hidden"
          name="EDP_BILL_NO"
          value={idramResponse?.edP_BILL_NO}
        />
        <input type="submit" ref={idramSubmitRef} value="submit" />
      </form>

      {/* <form
        action="https://telcellmoney.am/invoices"
        style={{ display: "none" }}
        method="POST"
      >
        <input type="hidden" name="issuer" value={telcellResponse?.issuer} />
        <input type="hidden" name="action" value="PostInvoice" />
        <input
          type="hidden"
          name="currency"
          value={telcellResponse?.currency}
        />
        <input type="hidden" name="price" value={telcellResponse?.price} />
        <input type="hidden" name="product" value={telcellResponse?.product} />
        <input
          type="hidden"
          name="issuer_id"
          value={telcellResponse?.issuer_id}
        />
        <input
          type="hidden"
          name="valid_days"
          value={telcellResponse?.valid_days}
        />
        <input type="hidden" name="lang" value="AM" />
        <input
          type="hidden"
          name="security_code"
          value={telcellResponse?.security_code}
        />
        <input type="submit" ref={telcellSubmitRef} value="Submit" />
      </form> */}
    </Fragment>
  );
};

export default Price;
